import { useTheme } from "context/ThemeContext";
import { Button, ButtonPropTypes } from "./Button";

const PrimaryButton = ({ disabled, style = {}, ...resProps }) => {
  const { theme } = useTheme();
  const primaryStyle = {
    opacity: disabled ? "65%" : undefined,
    backgroundColor: theme.primaryColor,
    color: "#fff",
    ...style,
  };

  return <Button {...resProps} style={primaryStyle} disabled={disabled} />;
};
PrimaryButton.propTypes = ButtonPropTypes;

export default PrimaryButton;
